import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = { class: "grid col-12 p-0 m-0 justify-content-center align-items-center" }
const _hoisted_3 = { class: "grid col-12 px-6 py-0 m-0 justify-content-between align-items-start" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", {
  id: "header-contact-info",
  class: "p-0 m-0 mb-3"
}, "Select Shipping Address", -1)
const _hoisted_5 = {
  key: 0,
  class: "grid col-12 justify-content-center"
}
const _hoisted_6 = {
  key: 0,
  class: "grid col-12 p-0 m-0 justify-content-center"
}
const _hoisted_7 = {
  key: 0,
  class: "col-12 text-center p-4"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map-marker text-4xl text-400 mb-3" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-semibold mb-2" }, "No Addresses Found", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-base text-600" }, "Please add a shipping address to continue with your order.", -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "card pt-3"
}
const _hoisted_13 = {
  key: 0,
  class: "text-center p-0 m-0 text-base"
}
const _hoisted_14 = { class: "grid p-0 m-0" }
const _hoisted_15 = { class: "flex col-12 p-0 m-0 mb-1" }
const _hoisted_16 = {
  key: 0,
  class: "address-item text-base font-bold"
}
const _hoisted_17 = { class: "flex col-12 p-0 m-0 mb-2" }
const _hoisted_18 = {
  class: "address-item text-base font-normal",
  style: {"white-space":"pre-line"}
}
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = { class: "grid p-0 m-0 mt-2 justify-content-left pl-1 pr-2" }
const _hoisted_21 = { class: "grid p-1 m-0 col-12 md:col-6 xl:col-4" }
const _hoisted_22 = { class: "p-inputgroup h-2rem" }
const _hoisted_23 = {
  class: "p-inputgroup-addon font-semibold general-label-color",
  style: { width: '150px' }
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "p-error" }
const _hoisted_26 = {
  class: "p-inputgroup h-5rem mt-2",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("small", { class: "font-semibold mb-1" }, "Notes", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_CollapsibleSection = _resolveComponent("CollapsibleSection")!
  const _component_AddShippingAddressDialog = _resolveComponent("AddShippingAddressDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Button, {
            label: "Use New Address",
            icon: "pi pi-plus",
            onClick: _ctx.openAddAddressDialog,
            class: "text-center"
          }, null, 8, ["onClick"])
        ]),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_ProgressSpinner)
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.addressesCards().length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_Carousel, {
                    value: _ctx.addressesCards(),
                    numVisible: 4,
                    numScroll: 1,
                    responsiveOptions: _ctx.carouselResponsiveOptions
                  }, {
                    item: _withCtx((slotProps) => [
                      (_openBlock(), _createBlock(_component_Card, {
                        key: slotProps.data.ship_seq,
                        class: _normalizeClass(_ctx.getCardTitleClass(slotProps.data)),
                        onClick: ($event: any) => (_ctx.setShipAdr(slotProps.data))
                      }, {
                        title: _withCtx(() => [
                          (_ctx.isAddressSelected(slotProps.data))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Selected"))
                            : _createCommentVNode("", true)
                        ]),
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              (slotProps.data.ship_name)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(slotProps.data.ship_name), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.formattedAddress(slotProps.data)), 1)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["class", "onClick"]))
                    ]),
                    _: 1
                  }, 8, ["value", "responsiveOptions"])
                ]))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_CollapsibleSection, {
          isOpen: _ctx.sectionsStatus.extraInformation,
          header: "Additional Information",
          "onUpdate:isOpen": _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleSectionIcon('extraInformation')))
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("small", _hoisted_23, " PO Number " + _toDisplayString(!_ctx.PONumber && this.getCustomer.po_required === 'Y' ? '*' : ''), 1),
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: _ctx.PONumber,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.PONumber) = $event)),
                    onInput: _ctx.setPO,
                    class: _normalizeClass(["text-sm w-full", {
                        'p-invalid': _ctx.orderSubmitted && _ctx.v$.PONumber.required.$invalid,
                      }])
                  }, null, 8, ["modelValue", "onInput", "class"])
                ]),
                (_ctx.orderSubmitted && _ctx.v$.PONumber.required.$invalid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("small", _hoisted_25, _toDisplayString(_ctx.v$.PONumber.required.$message), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode(_component_TextArea, {
                    id: "my-info",
                    placeholder: "Insert information here...",
                    class: "text-sm w-full",
                    modelValue: _ctx.notes,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.notes) = $event)),
                    onInput: _ctx.setNote,
                    cols: "30",
                    rows: "5",
                    style: {"border-radius":"6px"}
                  }, null, 8, ["modelValue", "onInput"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["isOpen"])
      ])
    ]),
    _createVNode(_component_AddShippingAddressDialog, {
      header: "Use new address",
      showDialog: _ctx.showAddAddressDialog,
      addAddressToCustomerSwitch: true,
      customerId: _ctx.getCustomer.cust_id,
      onCloseDialog: _ctx.closeAddAddressDialog,
      onSaveAddress: _ctx.saveNewAddress
    }, null, 8, ["showDialog", "customerId", "onCloseDialog", "onSaveAddress"])
  ], 64))
}